import { SITE } from './site';

export const DEFAULT_KEYWORDS = [
  'товары для кондитеров Волгоград',
  'кондитерский магазин Волгоград',
  'украшения для тортов Волгоград',
  'посыпки для тортов',
  'топперы для торта',
  'домашняя выпечка',
  'декор для тортов',
  'ингредиенты для тортов',
  'пищевые красители',
  'формы для выпечки',
  'шоколад глазурь какао',
  'nextcake',
].join(', ');

export const SEO_PAGES = {
  home: {
    title: `Товары для кондитеров в Волгограде — магазин ${SITE.name}`,
    description:
      'Розничный магазин nextcake в Волгограде: посыпки, топперы, шоколад, формы, красители и декор для тортов. Для домашних кондитеров и тех, кто хочет испечь десерт или украсить торт. Более 3400 товаров, доставка по городу.',
    path: '/',
  },
  catalog: {
    title: `Каталог товаров для кондитеров — ${SITE.name} Волгоград`,
    description:
      'Каталог nextcake: кондитерские посыпки, топперы, подложки, коробки, шоколад, глазурь, красители и всё для домашней выпечки. Актуальные цены и наличие в магазине в Волгограде.',
    path: '/catalog',
  },
  retailStore: {
    title: `Розничный магазин товаров для кондитеров в Волгограде — ${SITE.name}`,
    description:
      `Магазин nextcake: ${SITE.address}. Посыпки, топперы, формы, шоколад и декор для тортов — всё в наличии. Для домашних кондитеров и любителей выпечки. Работаем ${SITE.hours.toLowerCase()}.`,
    path: '/retail-store',
  },
  delivery: {
    title: `Доставка товаров для кондитеров по Волгограду — ${SITE.name}`,
    description:
      `Оперативная доставка по Волгограду за 2 часа. Заказ в мессенджере MAX, курьер Яндекс Go. Кондитерские товары из магазина nextcake — ${SITE.address}.`,
    path: '/delivery',
  },
  foodPrinting: {
    title: `Пищевая печать на вафельной и сахарной бумаге — ${SITE.name} Волгоград`,
    description:
      'Фотопечать на вафельной и сахарной бумаге в Волгограде: картинки и фото для украшения тортов и десертов. Заказ в магазине nextcake.',
    path: '/food-printing',
  },
  studio: {
    title: `Аренда студии для мастер-классов — ${SITE.name} Волгоград`,
    description:
      'Светлая студия 35 м² в Дзержинском районе Волгограда для кулинарных мастер-классов, девичников и фотосъёмок. Рядом с магазином nextcake.',
    path: '/studio',
  },
  notFound: {
    title: `Страница не найдена — ${SITE.name}`,
    description:
      'Запрашиваемая страница не найдена. Перейдите в каталог nextcake — товары для кондитеров в Волгограде.',
  },
};

export function absoluteUrl(path = '/') {
  const base = SITE.url.replace(/\/$/, '');
  if (!path || path === '/') return `${base}/`;
  return path.startsWith('http') ? path : `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export function catalogSeo({ categoryName, query } = {}) {
  if (query) {
    return {
      title: `Поиск «${query}» — товары для кондитеров | ${SITE.name}`,
      description: `Результаты поиска «${query}» в магазине nextcake в Волгограде: товары для домашней выпечки, декора тортов и сладких десертов.`,
      path: `/catalog?q=${encodeURIComponent(query)}`,
    };
  }

  if (categoryName) {
    return {
      title: `${categoryName} купить в Волгограде — ${SITE.name}`,
      description: `${categoryName} для домашних кондитеров и любителей выпечки в магазине nextcake (Волгоград). В наличии, актуальные цены, самовывоз и доставка по городу.`,
      path: '/catalog',
    };
  }

  return SEO_PAGES.catalog;
}

export function productSeo(product) {
  const name = product?.name || 'Товар';
  const category = product?.categories?.[0]?.name;
  const categoryPart = category ? ` — ${category}` : '';
  const descSource =
    product?.description ||
    product?.full_name ||
    `${name}${categoryPart}. Купить в магазине nextcake в Волгограде: для домашней выпечки и украшения тортов.`;

  return {
    title: `${name} купить в Волгограде — ${SITE.name}`,
    description: String(descSource).replace(/\s+/g, ' ').trim().slice(0, 160),
    path: product?.id ? `/product/${product.id}` : '/',
    image: product?.images?.[0]?.url || product?.image_url,
  };
}
